import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';

import BrandingContext from '../../Context/BrandingContext';
import IconsContext from '../../Context/IconsContext';

export default memo(OrgFeatures);

function OrgFeatures(props) {
  const { primary_alert } = useContext(BrandingContext);
  const { cumminsIconBlack } = useContext(IconsContext);

  return (
    <div className="row">
      <div className="col-12">
        <div className="form-group">
          <label htmlFor="features" className="modal-inputlabel-text">
            Features Available
          </label>
          {!props.orgHasBillingEnabled && props.hasBilling ? (
            <div className="d-flex align-items-center mb-2">
              <Switch
                onChange={(e) =>
                  props.handleFeaturesUpdate({
                    target: { name: 'billingEnabled', value: e },
                  })
                }
                checked={props.billingEnabled}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="billingEnabled-toggle"
              />
              <p className="mb-0 ml-4 modal-inputlabel-text">
                Billing and Subscriptions
              </p>
            </div>
          ) : null}
          {props.hasRemote ? (
            <div className="d-flex align-items-center mb-2">
              <Switch
                onChange={(e) =>
                  props.handleFeaturesUpdate({
                    target: { name: 'remote', value: e },
                  })
                }
                checked={props.remote}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="remote-toggle"
              />
              <p className="mb-0 ml-4 modal-inputlabel-text">
                Command and Control
              </p>
            </div>
          ) : null}
          {props.hasCumminsenabled ? (
            <div className="d-flex align-items-center mb-2">
              <Switch
                onChange={(e) =>
                  props.handleFeaturesUpdate({
                    target: { name: 'cumminsenabled', value: e },
                  })
                }
                checked={props.cumminsenabled}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="cumminsenabled-toggle"
              />
              <div className="ml-4 d-flex align-items-center">
                <img
                  alt="cummins logo"
                  height={20}
                  src={cumminsIconBlack}
                  width={20}
                />
                <p className="mb-0 ml-1 modal-inputlabel-text">
                  Connected Diagnostics
                </p>
              </div>
            </div>
          ) : null}
          {props.hasCsvReports ? (
            <div className="d-flex align-items-center mb-2">
              <Switch
                onChange={(e) =>
                  props.handleFeaturesUpdate({
                    target: { name: 'csvExport', value: e },
                  })
                }
                checked={props.csvExport}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="csvExport-toggle"
              />
              <p className="mb-0 ml-4 modal-inputlabel-text">
                Fleet CSV Exports
              </p>
            </div>
          ) : null}
          {props.hasMaintenanceV1 ? (
            <div className="d-flex align-items-center mb-2">
              <Switch
                onChange={(e) =>
                  props.handleFeaturesUpdate({
                    target: { name: 'maintenance_v1', value: e },
                  })
                }
                checked={props.maintenance_v1}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="maintenance-v1-toggle"
              />
              <p className="mb-0 ml-4 modal-inputlabel-text">Maintenance v1</p>
            </div>
          ) : null}
          {props.hasMaintenanceV1 && props.hasParts ? (
            <div className="d-flex align-items-center mb-2 ml-5">
              <Switch
                onChange={(e) =>
                  props.handleFeaturesUpdate({
                    target: { name: 'parts', value: e },
                  })
                }
                checked={props.parts}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="parts-toggle"
              />
              <p className="mb-0 ml-4 modal-inputlabel-text">
                Maintenance Parts
              </p>
            </div>
          ) : null}
          {props.hasMaintenanceV2 ? (
            <div className="d-flex align-items-center mb-2">
              <Switch
                onChange={(e) =>
                  props.handleFeaturesUpdate({
                    target: { name: 'maintenance_v2', value: e },
                  })
                }
                checked={props.maintenance_v2}
                checkedIcon={false}
                uncheckedIcon={false}
                height={15}
                width={30}
                onColor={primary_alert}
                id="maintenance-v2-toggle"
              />
              <p className="mb-0 ml-4 modal-inputlabel-text">Maintenance v2</p>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

OrgFeatures.propTypes = {
  billingEnabled: PropTypes.bool,
  csvExport: PropTypes.bool,
  cumminsenabled: PropTypes.bool,
  handleFeaturesUpdate: PropTypes.func,
  hasBilling: PropTypes.bool,
  hasCsvReports: PropTypes.bool,
  hasCumminsenabled: PropTypes.bool,
  hasMaintenanceV1: PropTypes.bool,
  hasMaintenanceV2: PropTypes.bool,
  hasParts: PropTypes.bool,
  hasRemote: PropTypes.bool,
  maintenance_v1: PropTypes.bool,
  maintenance_v2: PropTypes.bool,
  orgHasBillingEnabled: PropTypes.bool,
  parts: PropTypes.bool,
  remote: PropTypes.bool,
};
